import React from 'react';
import { SlideLayout } from '../ui/SlideLayout';
import { LightbulbIcon } from 'lucide-react';
const metrics = ['Domain Authority', 'Organic Keywords', 'Organic Traffic', 'Referring Domains', 'Backlinks'];
const domains = [{
  name: 'mortgageprokingston.com',
  highlight: true,
  values: ['43', '245', '637', '170', '29.2K']
}, {
  name: 'truenorthmortgage.ca',
  highlight: false,
  values: ['70', '47K', '81.4K', '1,500', '13.3K']
}, {
  name: 'mortgageforces.ca',
  highlight: false,
  values: ['13', '2,200', '1,600', '95', '272']
}, {
  name: 'kingstonmortgagesolutions.com',
  highlight: false,
  values: ['34', '91', '177', '67', '129']
}, {
  name: 'karenmatthey.ca',
  highlight: false,
  values: ['12', '29', '79', '109', '124']
}];
// Mobile card view for each competitor
const CompetitorCard = ({
  domain
}: {
  domain: (typeof domains)[0];
}) => <div className={`glass-card p-4 ${domain.highlight ? 'ring-2 ring-gold-500/30 bg-gold-500/5' : ''}`} data-id="element-67">
    <h4 className={`text-sm font-bold mb-3 truncate ${domain.highlight ? 'text-gold-600' : 'text-slate-700'}`} data-id="element-68">
      {domain.name}
    </h4>
    <div className="grid grid-cols-2 gap-2" data-id="element-69">
      {metrics.map((metric, j) => <div key={j} className="flex flex-col" data-id="element-70">
          <span className="text-[10px] text-slate-400 uppercase tracking-wider font-semibold" data-id="element-71">
            {metric}
          </span>
          <span className={`text-sm font-bold ${domain.highlight ? 'text-slate-900' : 'text-slate-600'}`} data-id="element-72">
            {domain.values[j]}
          </span>
        </div>)}
    </div>
  </div>;
export function CompetitorBenchmark() {
  return <SlideLayout data-id="element-73">
      <div className="mb-6 sm:mb-10" data-id="element-74">
        <div className="w-12 h-1 bg-gold-500 mb-4 sm:mb-6 rounded-full" data-id="element-75" />
        <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-2 sm:mb-4" data-id="element-76">
          Competitor Benchmarking
        </h2>
        <p className="text-sm sm:text-xl text-slate-500" data-id="element-77">
          Understanding the competitive landscape reveals SEO gaps and ranking
          opportunities.
        </p>
      </div>

      {/* Desktop table view */}
      <div className="hidden sm:block glass-card overflow-hidden mb-6 sm:mb-8" data-id="element-78">
        <div className="overflow-x-auto" data-id="element-79">
          <table className="w-full text-left border-collapse" data-id="element-80">
            <thead data-id="element-81">
              <tr className="bg-slate-50 border-b border-slate-200" data-id="element-82">
                <th className="p-3 sm:p-5 text-xs sm:text-sm font-bold text-slate-500 uppercase tracking-wider" data-id="element-83">
                  Domain
                </th>
                {metrics.map((metric, i) => <th key={i} className="p-3 sm:p-5 text-xs sm:text-sm font-bold text-slate-500 uppercase tracking-wider text-center" data-id="element-84">
                    {metric}
                  </th>)}
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-85">
              {domains.map((domain, i) => <tr key={i} className={domain.highlight ? 'bg-gold-500/5' : 'hover:bg-slate-50 transition-colors'} data-id="element-86">
                  <td className={`p-3 sm:p-5 font-medium text-xs sm:text-base ${domain.highlight ? 'text-gold-600 font-bold' : 'text-slate-600'}`} data-id="element-87">
                    {domain.name}
                  </td>
                  {domain.values.map((val, j) => <td key={j} className={`p-3 sm:p-5 text-center text-xs sm:text-base ${domain.highlight ? 'text-slate-900 font-bold' : 'text-slate-600'}`} data-id="element-88">
                      {val}
                    </td>)}
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      {/* Mobile card view */}
      <div className="sm:hidden space-y-3 mb-6" data-id="element-89">
        {domains.map((domain, i) => <CompetitorCard key={i} domain={domain} data-id="element-90" />)}
      </div>

      <div className="flex items-start gap-3 sm:gap-4 p-4 sm:p-6 rounded-xl border border-gold-500/30 bg-gradient-to-r from-slate-50 to-white shadow-sm" data-id="element-91">
        <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-gold-500/15 flex items-center justify-center shrink-0" data-id="element-92">
          <LightbulbIcon className="w-5 h-5 sm:w-6 sm:h-6 text-gold-600" data-id="element-93" />
        </div>
        <div data-id="element-94">
          <h4 className="text-sm sm:text-lg font-bold text-slate-900 mb-1 sm:mb-2" data-id="element-95">
            Strategic Insight
          </h4>
          <p className="text-xs sm:text-base text-slate-700 leading-relaxed" data-id="element-96">
            While truenorthmortgage.ca dominates with 70 DA and 81.4K monthly
            traffic, Mortgage Pro Kingston holds a strong backlink profile at
            29.2K. The opportunity lies in closing the organic keyword and
            traffic gap through targeted service pages, location content, and
            strategic SEO — areas where local competitors like
            kingstonmortgagesolutions.com and karenmatthey.ca are also
            underperforming.
          </p>
        </div>
      </div>
    </SlideLayout>;
}